import styled, { createGlobalStyle } from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const ContactGlobalStyle = createGlobalStyle`
  html, body {
    background: ${homeColor.bg};
  }
`;

export const PageWrapper = styled.main`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  color: ${homeColor.white};
  background: ${homeColor.bg};
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  overflow-x: clip;
  position: relative;
`;
